// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__W4TY-","wrapper-nopadding":"wrapper-nopadding__1fgA-","loading":"loading__1aWFv","error":"error__2HJxK","table-loading":"table-loading__3VULf","empty-val":"empty-val__2JxiE","panelheader-tools":"panelheader-tools__LYmCA","propsPanels":"propsPanels__3Ge43","new":"new__HAfdt","marginLm":"marginLm__3KThf","marginRm":"marginRm__gWR-9","fullWidth":"fullWidth__2JS7A","fullHeight":"fullHeight__2y8PL","noData":"noData__XcAxe","compact":"compact__3cabo","dataTable":"dataTable__CkG4P","pager":"pager__22Tym","marinRight":"marinRight__xTaTX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayData/styles.scss
// module id = 830
// module chunks = 1